import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    actionName: string;
    subtitle: ({ assetCount }: {
        assetCount: number;
    }) => string;
    outputInfo: string;
    confirm: string;
    cancel: string;
    dialogCloseLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Name of the remove background action. */
            actionName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.actionName?c=34dwjo0zjm2ot", defaultMessage: "Remove Background" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Confirmation copy describing how many images will be processed. */
            subtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ assetCount }: {
                        assetCount: number;
                    }): string => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.subtitle?c=1ewdjgkae4kw2", defaultMessage: "{assetCount, plural, one {Remove the background from the selected image.} other {Remove the background from {assetCount, number} selected images.}}" }, { assetCount: assetCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Informational note describing the output of the action. */
            outputInfo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.outputInfo?c=2pg8w48l362oz", defaultMessage: "Output will be PNGs with transparent backgrounds in a new folder." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Confirm button text. */
            confirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.confirm?c=34dwjo0zjm2ot", defaultMessage: "Remove Background" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button text. */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label to close the dialog. */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyRemoveBackgroundDialog.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
